// redux/slices/pageSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface PageState {
    currentPage: string;
    dafaplusPreChatStep: 'faq' | 'category';
}

const initialState: PageState = {
    currentPage: 'pre-chat', // default page
    dafaplusPreChatStep: 'faq',
};

const pageSlice = createSlice({
    name: 'page',
    initialState,
    reducers: {
        setPage(state, action: PayloadAction<string>) {
            state.currentPage = action.payload;
        },
        setDafaplusPreChatStep(state, action: PayloadAction<'faq' | 'category'>) {
            state.dafaplusPreChatStep = action.payload;
        },
    },
});

export const { setPage, setDafaplusPreChatStep } = pageSlice.actions;
export default pageSlice.reducer;
